import React from "react";
import { Layout, Avatar, Dropdown } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Header } = Layout;

const HeaderBar = () => {
    const menuItems = [
        { key: "1", label: "Profil" },
        { key: "2", label: "Déconnexion" },
    ];

    return (
        <Header style={{ background: "#fff", display: "flex", justifyContent: "flex-end" }}>
            <Dropdown menu={{ items: menuItems }}>
                <Avatar icon={<UserOutlined />} style={{ cursor: "pointer" }} />
            </Dropdown>
        </Header>
    );
};

export default HeaderBar;